import React, { useState, useEffect } from "react";
import { fetchJson } from "../../lib/Fetching";
import Loading from "../common/Loading";

export default function SampleLedgerView({ sample_id }) {
  const [sampleLedger, setSampleLedger] = useState(null);

  useEffect(
    () => {
      fetchJson("/invoicing/sample_ledgers/" + sample_id, {}).then((json) => {
        setSampleLedger(json);
      });
    },
    [sample_id]
  );

  if (!sampleLedger) return <Loading loading={true} />;

  return (
    <div style={{ margin: "0 auto", maxWidth: 950 }}>
      <table className="table table-condensed">
        <thead>
          <tr>
            <th>Type</th>
            <th>Date Sample Charge Created</th>
            <th>NET Amount (excluding any VAT)</th>
            <th>Invoice ID</th>
            <th>Invoice Sent</th>
          </tr>
        </thead>
        <tbody>
          {sampleLedger.map((ledgerItem) => (
            <tr>
              <td>{ledgerItem.type}</td>
              <td>{ledgerItem.charge_created_date}</td>
              <td>{ledgerItem.net_amount}</td>
              <td>
                {!ledgerItem.invoice_id && "Not on Invoice"}
                {ledgerItem.invoice_id && (
                  <a href={"/invoicing/invoices/" + ledgerItem.invoice_id} target="_blank">
                    {ledgerItem.invoice_number}
                  </a>
                )}
              </td>
              <td>{ledgerItem.invoice_sent_at || "Not sent yet"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
